import { useState } from "react";
import { Button, Stack } from "@mui/material";

const SaveMovedEvals = ({ onSave, disabled }) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    await onSave();
    setIsSaving(false);
  };

  return (
    <Stack>
      <Button
        variant="contained"
        color="secondary"
        style={{ width: "200px" }}
        onClick={handleSave}
        disabled={isSaving || disabled}
      >
        Save
      </Button>
    </Stack>
  );
};

export default SaveMovedEvals;
